import React from 'react';
import { CustomizedTypography } from '@components/Customized';
import { colorSet } from '@components/Provider';
import { Box, useTheme, useMediaQuery, makeStyles } from '@material-ui/core';
import { InfoOutlined, ChevronRight } from '@material-ui/icons';

const useStyles = makeStyles((theme) => {
  return {
    root: {
      textAlign: 'left',
      marginBottom: 84,
      '& .title-description': {
        cursor: 'pointer',
        display: 'flex',
        alinItems: 'center',
        justifyContent: 'center',
        color: colorSet.gray700,
        '& .MuiSvgIcon-root': {
          '&:first-child': {
            marginRight: 8
          },
          '&:last-child': {
            marginLeft: 4
          }
        },
        marginBottom: 40
      },
      [theme.breakpoints.down('xs')]: {
        marginBottom: 100
      }
    },
    titleBox: {
      borderRadius: 4,
      border: `1px solid ${colorSet.gray400}`,
      color: colorSet.gray600,
      padding: '16px 0px',
      marginBottom: 8,
      [theme.breakpoints.down('xs')]: {
        marginBottom: 12
      }
    },
    uploadBox: {
      cursor: 'pointer',
      padding: '28px 0px',
      backgroundColor: colorSet.primary200,
      border: `1px dashed ${colorSet.primary500}`,
      textAlign: 'center',
      '& .MuiTypography-colorTextPrimary': {
        '&:first-child': {
          '& span': {
            fontSize: 14,
            fontWeight: 'normal'
          }
        }
      },
      '& .MuiTypography-colorPrimary': {
        '& span': {
          color: colorSet.gray600
        }
      }
    },
    [theme.breakpoints.down('xs')]: {
      padding: '30px 0px'
    }
  };
});

interface Props {
  onClick: () => void;
}

const DrawingFileUploadPresenter: React.FC<Props> = ({ onClick }) => {
  const theme = useTheme();
  const matches = useMediaQuery(theme.breakpoints.down('xs'));
  const classes = useStyles();

  return (
    <div className={classes.root}>
      <CustomizedTypography
        variant={matches ? 'h3' : 'h2'}
        fontWeight="bold"
        color="textPrimary"
        gutterBottoms={matches ? 12 : 8}
        align="center"
      >
        도면 업로드 후{matches ? <br /> : ''} 재료와 수량을 입력해주세요
      </CustomizedTypography>
      <div className="title-description" onClick={onClick}>
        <InfoOutlined fontSize="small" />
        <CustomizedTypography variant="body2" fontWeight="500" color="primary">
          도면이 없다면?
        </CustomizedTypography>
        <ChevronRight fontSize="small" />
      </div>
      <Box className={classes.titleBox}>
        <CustomizedTypography variant="body2" color="inherit" align="center">
          업로드한 도면이 없습니다. 도면 파일을 업로드 해주세요.
        </CustomizedTypography>
      </Box>
      <Box className={classes.uploadBox} onClick={onClick}>
        <CustomizedTypography
          variant={matches ? 'body2' : 'body1'}
          color="textPrimary"
          fontWeight="500"
          gutterBottoms={4}
        >
          도면 파일을 이곳에 드래그 <span>또는</span>
        </CustomizedTypography>
        <CustomizedTypography
          variant="body1"
          color="primary"
          fontWeight="500"
          gutterBottoms={12}
        >
          내 PC에서 첨부 <span>/</span> 드라이브에서 첨부
        </CustomizedTypography>
        <CustomizedTypography variant="caption" color="textPrimary">
          파일 확장자 : .dwg, .dxf, .stp, .step
        </CustomizedTypography>
        <CustomizedTypography variant="caption" color="textSecondary">
          (최대 20개 업로드, 1개당 100MB 이하)
        </CustomizedTypography>
      </Box>
    </div>
  );
};

export default DrawingFileUploadPresenter;
